import { FormField } from 'src/components/custom-dialog/CustomDialog';
import styleVariables from '../scss/_variables.scss';

export const MOBILE_MAX_WIDTH_PX = 800;

export const DATA_GRID_COLUMN_WIDTH = 500;

export const DATA_GRID_COLUMN_WIDTH_2 = 150;

export const DATA_GRID_COLUMN_WIDTH_3 = 170;

export const DATA_GRID_COLUMN_WIDTH_4 = 260;

export const DATA_GRID_COLUMN_WIDTH_5 = 250;

export const DATA_GRID_COLUMN_WIDTH_6 = 445;

export const DATA_GRID_COLUMN_WIDTH_7 = 255;

export const DATA_GRID_COLUMN_WIDTH_WINDOW_60 = window.innerWidth * 0.6;

export const GLOBAL_MEMORY_COLUMN_WIDTH = 160;

export const AVATAR_HEIGHT_WIDTH = 112;

export const STYLE_FOR_LARGE_DIALOG = {
  width: '80vw',
  height: '80vh',
  maxWidth: 'none',
  maxHeight: 'none',
};

export const TASK_UPDATE_DIALOG_MAX_WIDTH = 'sm';
export const TASK_UPDATE_DIALOG_MIN_WIDTH = 520;

export const STYLE_FOR_POP_DIALOG = {
  boxShadow: `0 0 4px ${styleVariables.hanabiThemeColorBrightOrangeRed}`,
};

export const DEFAULT_MULTILINE_ROW_FOR_TEXT_AREA = 5;

export const HANA_ACCESS_DAILOG_IMG_SIZE = 200;

export const AUTOCOMPLETE_LOADING_INDICATOR_SIZE = 20;

export const FULL_WIDTH = '100%';

export const TAB_STYLES = {
  marginBottom: 4,
  '& .MuiTab-root.Mui-selected': {
    color: styleVariables.colorWhite,
  },
  '& .MuiTabs-indicator': {
    backgroundColor: styleVariables.hanabiThemeColorDarkRed,
  },
};

export const getTextFieldStyles = (field: FormField) => {
  const styles = {
    textareaInput: {
      padding: '8px',
    },
    maxLengthHelperText: { textAlign: 'right' },
  };

  if (field.type === 'textarea') {
    return {
      ...styles,
      textareaInput: {
        ...styles.textareaInput,
        display: 'flex',
        alignItems: 'flex-start',
        minHeight: '20vh',
        flex: 1,
      },
    };
  }

  if (field.type === 'date-time' || field.type === 'date') {
    return {
      ...styles,
      '.MuiFormHelperText-root': { marginLeft: 0 },
      '& .MuiOutlinedInput-root': {
        border: 'none',
        width: 'max-content',
      },
    };
  }

  return styles;
};
